"use strict";

// Append name to help question when input for 'fname' changes
$(function () {
  $('input#fName').on('change', function () {
    var name = $(this).val();
    $('#your-name').fadeOut('fastest', function () {
      $(this).text(', ' + name);
      $(this).fadeIn('fastest');
    });
  });
}); // Sharpspring Form Submission (Contact form)

$('#envano-contact').on('submit', function (event) {
  event.preventDefault();
  var sharpspring = {
    baseURI: 'https://app-FZTQO9V2.marketingautomation.services/webforms/receivePostback/MzQwNLcwNQcA/',
    endpoint: '1f0db2f0-d76f-4446-b0e1-53631e6279c7'
  },
      script = document.createElement('script'),
      body = document.getElementsByTagName('body')[0] || document.documentElement,
      params,
      url;
  params = $(this).serialize(); //create url for post on Sharp Spring

  url = sharpspring.baseURI + sharpspring.endpoint + '/jsonp/?' + params; //create script

  script.src = url; //append script to body

  body.appendChild(script); //when the form is submited

  script.onload = script.onreadystatechange = function (event) {
    body.removeChild(script);
    $('#envano-contact').fadeOut('fast');
    $('#thank-you').fadeIn('slow');
  };
}); // Sharpspring Form Submission (Recruiting Webinar form)

$('#recruiting-webinar-form').on('submit', function (event) {
  event.preventDefault();
  var sharpSpring = {
    baseURI: 'https://app-FZTQO9V2.marketingautomation.services/webforms/receivePostback/MzQwNLcwNQcA/',
    endpoint: 'ad73b4f4-a2e6-47df-b845-ed2eb8665ed6'
  },
      script = document.createElement('script'),
      body = document.getElementsByTagName('body')[0] || document.documentElement,
      params,
      url;
  params = $(this).serialize(); //create url for post on Sharp Spring

  url = sharpSpring.baseURI + sharpSpring.endpoint + '/jsonp/?' + params; //create script

  script.src = url; //append script to body

  body.appendChild(script); //when the form is submited

  script.onload = script.onreadystatechange = function (event) {
    body.removeChild(script);
    $('#recruiting-webinar-form').fadeOut('fast');
    $('#thank-you').fadeIn('slow');
  };
}); // Sharpspring Form Submission (SEO Webinar form)

$('#seo-webinar-form').on('submit', function (event) {
  event.preventDefault();
  var sharpSpring = {
    baseURI: 'https://app-FZTQO9V2.marketingautomation.services/webforms/receivePostback/MzQwNLcwNQcA/',
    endpoint: '5b4eadaa-4d1b-4e1a-b4c4-b7ae164ef5bd'
  },
      script = document.createElement('script'),
      body = document.getElementsByTagName('body')[0] || document.documentElement,
      params,
      url;
  params = $(this).serialize(); //create url for post on Sharp Spring

  url = sharpSpring.baseURI + sharpSpring.endpoint + '/jsonp/?' + params; //create script

  script.src = url; //append script to body

  body.appendChild(script); //when the form is submited

  script.onload = script.onreadystatechange = function (event) {
    body.removeChild(script);
    $('#seo-webinar-form').fadeOut('fast');
    $('#thank-you').fadeIn('slow');
  };
}); // Sharpspring Form Submission (Blog posts)

$('#blog-post-contact').on('submit', function (event) {
  var sharpspring = {
    baseURI: 'https://app-FZTQO9V2.marketingautomation.services/webforms/receivePostback/MzQwNLcwNQcA/',
    endpoint: 'e0bc7ed2-94c2-4849-9e5f-33ab42b5ec56'
  },
      script = document.createElement('script'),
      body = document.getElementsByTagName('body')[0] || document.documentElement,
      params,
      url;
  params = $(this).serialize(); //create url for post on Sharp Spring

  url = sharpspring.baseURI + sharpspring.endpoint + '/jsonp/?' + params; //create script

  script.src = url; //append script to body

  body.appendChild(script); //when the form is submited

  script.onload = script.onreadystatechange = function (event) {
    body.removeChild(script);
    $('#blog-post-contact').fadeOut('fast');
    $('#thank-you').fadeIn('slow');
  };
}); // Sharpspring Form Submission (E-Newsletter Subscription)

$('#footer-newsletter-subscribe').on('submit', function (event) {
  event.preventDefault();
  var sharpspring = {
    baseURI: 'https://app-FZTQO9V2.marketingautomation.services/webforms/receivePostback/MzQwNLcwNQcA/',
    endpoint: '0656ab4b-3816-4c18-9ec7-9c6a7f30802b'
  },
      script = document.createElement('script'),
      body = document.getElementsByTagName('body')[0] || document.documentElement,
      params,
      url;
  params = $(this).serialize(); //create url for post on Sharp Spring

  url = sharpspring.baseURI + sharpspring.endpoint + '/jsonp/?' + params; //create script

  script.src = url; //append script to body

  body.appendChild(script); //when the form is submited

  script.onload = script.onreadystatechange = function (event) {
    body.removeChild(script);
    $('#footer-newsletter-subscribe').fadeOut('fast');
    $('#newsletter-thank-you').fadeIn('slow');
  };
});